import { types } from 'mobx-state-tree';
import {
  OverdueMetersReportStore,
  RequestsReportStore,
} from './reports-models';

export const ReportsStore = types.model({
  overdue_meters: types.optional(OverdueMetersReportStore, {}),
  requests: types.optional(RequestsReportStore, {}),
});
